import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import FleetManagementApiService from './FleetManagementApiService'
import { GET_SAVE_RECEIVING_BRANCH } from '../../Store/FleetManagement/FleetTransferReceivingBranch/FleetTransferReceivingBranchType'
import { setSaveReceivingBranch } from 'Store/FleetManagement/FleetTransferReceivingBranch/FleetTransferReceivingBranchAction';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* SaveReceivingBranchDetailsSaga(req: any): any {
    try {
        yield put(globalLoaderText("Updating the Receiving Branch...."));

        let payloadData : IPayload= {
            apiType : apiType.FleetManagement,
            endpoint : `fleet/asset/items/receivingBranch`, 
            apiMethod :  apiMethod.PUT,
            payload : req?.saveReceivingBranch
            
        }

        const response = yield call(
            FleetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if (response) {
            yield put(setSaveReceivingBranch(response))
            yield put(globalLoaderText(""));
        }
    } catch (error) {
        yield put(globalLoaderText(""));
    }
}

function* watchGetFleetItemCancel() {
    yield takeEvery(GET_SAVE_RECEIVING_BRANCH, SaveReceivingBranchDetailsSaga)
}

export default function* combinedSaga() {
    yield all([
        watchGetFleetItemCancel()
    ])
}
